import { ActivityPointSeasonDto } from '@diritto/common/activityPoint/dtos/activity-point.dtos';
import { DateTime } from 'luxon';
import { ContentBodyContainer } from 'ui-components/layout/containers/ContentBodyCenterContainer';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { configure } from 'utils/configure';
import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import React from 'react';
import { diffDateTimeFormat } from '@diritto/common/utils/date';
import { useActivityPointReward } from 'state-hooks/activityPoint/useActivityPointReward';

export const QuestRankingRewardInfo = ({ season }: { season: ActivityPointSeasonDto }) => {
  const startAt = DateTime.fromJSDate(new Date(season.startAt));
  const endAt = DateTime.fromJSDate(new Date(season.endAt));

  const startAtString = startAt.toFormat('yyyy년 M월 d일');
  const endAtString = diffDateTimeFormat(startAt, endAt);
  const { rewardDescriptions } = useActivityPointReward(season);

  return (
    <ContentBodyContainer>
      <StyledRankingRewardInfoDate>{`시즌 ${startAtString}부터 ${endAtString}까지`}</StyledRankingRewardInfoDate>
      <StyledRankingRewardInfoContainer>
        <StyledRankingRewardInfoWrapper>
          <StyledRankingRewardInfoTitle>시즌 {season.title}</StyledRankingRewardInfoTitle>
          <StyledRankingRewardInfoDescWrapper>
            {rewardDescriptions?.map(description => (
              <StyledRankingRewardInfoDesc key={description.desc}>
                <img alt={description.iconSrc} src={description.iconSrc} width={13} height={20} />
                {description.desc}
              </StyledRankingRewardInfoDesc>
            ))}
          </StyledRankingRewardInfoDescWrapper>
        </StyledRankingRewardInfoWrapper>
        <StyledRankingRewardInfoImageWrapper>
          <img
            alt="dirittoLogo"
            src={`${configure.staticPrefix}/images/quest/dirittoLogo3d.png`}
            width={124}
            height={120}
          />
        </StyledRankingRewardInfoImageWrapper>
      </StyledRankingRewardInfoContainer>
    </ContentBodyContainer>
  );
};

const StyledRankingRewardInfoDate = styled.div`
  margin-top: 16px;
  color: ${Color.Gray600};
  font-weight: ${FontWeight.Medium};
  ${Typography.XXXSmall};
`;

const StyledRankingRewardInfoContainer = styled.div`
  margin-top: 13px;
  display: flex;
  flex-direction: row;
`;

const StyledRankingRewardInfoWrapper = styled.div`
  margin-top: 3px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

const StyledRankingRewardInfoImageWrapper = styled.div`
  flex-grow: 0;
  flex-direction: column;

  img {
    object-fit: contain;
  }
`;

const StyledRankingRewardInfoTitle = styled.div`
  margin-top: 3px;
  color: ${Color.Black};
  font-weight: ${FontWeight.Bold};
  ${Typography.XXLarge};
`;

const StyledRankingRewardInfoDescWrapper = styled.div`
  margin-top: 8px;
  color: ${Color.Gray500};
  font-weight: ${FontWeight.Medium};
  ${Typography.XXSmall};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledRankingRewardInfoDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
